<script setup lang="ts">
defineProps<{
  severity: 'high' | 'medium' | 'low';
  count: number;
}>();

const STYLES: Record<'high' | 'medium' | 'low', string> = {
  high: 'tw:bg-vuln-high-light tw:text-vuln-high tw:border-vuln-high/40',
  medium: 'tw:bg-vuln-medium-light tw:text-[#a87f00] tw:border-vuln-medium/50',
  low: 'tw:bg-vuln-low-light tw:text-vuln-low tw:border-vuln-low/40',
};
</script>

<template>
  <span
    class="tw:inline-flex tw:items-center tw:justify-center tw:min-w-6 tw:px-2 tw:py-0.5 tw:rounded-full tw:border tw:text-xs tw:font-medium"
    :class="STYLES[severity]"
  >
    {{ count }}
  </span>
</template>
